type NoteAuthorFields = {
  updated_by?: string | null
  updatedBy?: {
    first_name?: string | null
    last_name?: string | null
  } | null
}

/**
 * "{FirstInitial}.{last_name}" when both exist; partial fallbacks when only one side exists.
 */
export function formatNoteUpdaterInitialLast(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const first = (firstName ?? '').trim()
  const last = (lastName ?? '').trim()
  if (first.length > 0 && last.length > 0) {
    return `${first.charAt(0).toUpperCase()}.${last}`
  }
  if (last.length > 0) {
    return last
  }
  if (first.length > 0) {
    return `${first.charAt(0).toUpperCase()}.`
  }
  return ''
}

/** Sidebar / list footer: prefer joined user names, else first UUID segment of `updated_by`. */
export function getNoteSidebarAuthorLabel(note: NoteAuthorFields): string {
  const label = formatNoteUpdaterInitialLast(
    note.updatedBy?.first_name,
    note.updatedBy?.last_name,
  )
  if (label.length > 0) {
    return label
  }
  return note.updated_by?.split('-')[0] ?? ''
}
